import AssetCover from "common/features/asset/AssetCover";
import styles from "./TitleCard.module.scss";
import { FormattedMessage } from "react-intl";
import { useRequiredCode } from "../index/useRequiredCode";
import { CourseMaterial } from "../index/coursesLoader";
import { GroupedOffers } from "common/api/decimal/methods/compareAndPurchase";

interface TitleCardProps
  extends Pick<CourseMaterial, "vbid" | "title" | "requiredCode" | "author">,
    Pick<GroupedOffers, "publisher" | "edition" | "copyrightYear"> {}

export default function TitleCard({
  vbid,
  title,
  requiredCode,
  author,
  publisher,
  edition,
  copyrightYear,
}: TitleCardProps) {
  const code = useRequiredCode({ requiredCode });

  return (
    <div className={styles.container}>
      <div className={styles.coverRow}>
        <div className={styles.cover}>
          <AssetCover vbid={vbid} width={150} width2x={320} />
        </div>
        <div className={styles.metadataContainer}>
          <div className={styles.requiredCode}>
            <div>{code}</div>
          </div>

          <h1 className={styles.title}>{title}</h1>

          <div className={styles.metadata}>{edition}</div>

          <div className={styles.metadata}>{author}</div>

          <div className={styles.metadata}>{publisher}</div>

          <div className={styles.metadata}>
            <FormattedMessage
              defaultMessage="ISBN: {isbn}"
              values={{ isbn: vbid }}
            />
          </div>

          {copyrightYear && (
            <div className={styles.metadata}>
              <FormattedMessage
                defaultMessage={"Copyright {year}"}
                values={{ year: copyrightYear }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
